import { MapMarkerData } from '../map-utils';
import { signalStore, withHooks } from '@ngrx/signals';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFocusedLocation } from '../../location-list/state/location-list-selectors';
import { selectCanContinueAfterValidation } from '../state/map-combined.selectors';
import { withCvMapState } from './cv-map-state.feature';
import { withCvMarkers } from './cv-map-markers.feature';
import { withCvActions } from './cv-map-actions.feature';
import { withCvMapLifecycle } from './cv-map-lifecycle.feature';
import { ValidationHistoryActions } from '../../location-list/state/location-list-actions';
import { selectShowValidationHistory } from '../state/map-selectors';
import * as skeletonSelectors from '../../state/locations-skeleton-selectors';
import { BottomPanelTabs } from '../../locations-skeleton.component';

export interface CvMapSignalStore {
  // could be a signal entity, but maybe overkill since there won't be that many markers/validation data
  // https:ngrx.io/guide/signals/signal-store/entity-management
  markers: MapMarkerData[],
  autocompleteMarker: MapMarkerData,
  customMarker: MapMarkerData,
  infoWindowMarkerId: string,
  hoveredMarkerId: string,
  continueAfterValidation: boolean;
  mapsFullyRendered: boolean; // it is truly safe now to access googleMaps object (inc. streetView)
  streetViewLoading: boolean; // looking for street view center
  // true when bounds change, idle sets to false - avoid triggering clustering or marker rendering
  // while camera is panning or zooming
  // https://mapsplatform.google.com/resources/blog/google-maps-platform-best-practices-optimization-and-performance-tips/
  mapLoading: boolean;
}

export const cvMapSignalStore = signalStore(
    withCvMapState(),
    withCvMapLifecycle(),
    withCvMarkers(),
    withCvActions(),
    withHooks({
      onInit(signalStore, store = inject(Store)) {
        const isValidationHistoryTabActive = store.selectSignal(skeletonSelectors.selectBottomPanelActive)() &&
            store.selectSignal(skeletonSelectors.selectSelectedBottomPanelTab)() === BottomPanelTabs.VALIDATION_HISTORY;

        // get cv history on init (module effect handles syncing on location update)
        store.dispatch(ValidationHistoryActions.getValidationHistory({
          locationId: store.selectSignal(selectFocusedLocation)().id,
          lastValidationOnly: isValidationHistoryTabActive ?
              false :
              !store.selectSignal(selectShowValidationHistory)()
        }));
        // start effects
        signalStore.generateMarkers();
        signalStore.overrideContinueAfterValidation(store.select(selectCanContinueAfterValidation));
        signalStore.clearTransientMarkers(store.select(selectFocusedLocation));
      },
    }),
);

